/* global CustomEvent */

import styled from 'styled-components'
import { SecondaryButton } from '@PipelineDeals/shared-react-components'
import { notify } from 'utils/notify'

export const handleSubmitSuccess = (background, title, msg, backgroundMsg) => {
  if (!background) {
    const ev = new CustomEvent('list_view:refresh')
    window.dispatchEvent(ev)

    notify(title, { message: msg, type: 'success' })
  } else {
    notify(title, { message: backgroundMsg, type: 'in-progress' })
  }
}

export const handleSubmitFailure = (title, msg) => {
  notify(title, { message: msg, type: 'error' })
}

export const BodyWrapper = styled.div`
  padding: 0 15px;
  flex: 1;
`

export const CenteredWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 100%;
`

export const RowWrapper = styled.div`
  margin-top: 15px;
  margin-bottom: 15px;
`

export const SecondaryButtonWrapper = styled(SecondaryButton)`
  margin-right: 15px !important;
`
